// TrustIcons.jsx
import React from "react";
import { CheckCircle, Leaf, Calendar, MapPin } from "lucide-react";

const items = [
  {
    icon: <CheckCircle className="w-6 h-6 text-green-600" />,
    label: "Licensed & Insured",
  },
  {
    icon: <Leaf className="w-6 h-6 text-green-600" />,
    label: "Eco-Friendly Products",
  },
  {
    icon: <Calendar className="w-6 h-6 text-green-600" />,
    label: "Flexible Service Plans",
  },
  {
    icon: <MapPin className="w-6 h-6 text-green-600" />,
    label: "Locally Owned & Operated",
  },
];

const TrustIcons = () => (
  <section className="bg-green-50 py-12 px-6 text-center">
    <h2 className="text-2xl font-semibold text-green-800 mb-8">
      Why Choose LawnSmartPro
    </h2>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-4xl mx-auto">
      {items.map((item, idx) => (
        <div key={idx} className="flex flex-col items-center">
          {item.icon}
          <span className="text-sm text-gray-700 mt-2">{item.label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustIcons;
